<script setup lang="ts">import { ref as _ref, toRef as _toRef } from 'vue';
const __props_currentUser = _toRef(__props, 'currentUser');

import type { CurrentUser, FeaturedCity } from '@consumer/types/serializers'
import { useScreen } from '@consumer/helpers/screen'
import GiftlyLogoSvg from './Header/GiftlyLogoSvg.vue'
import HeaderCheckout from './HeaderCheckout.vue'
import HeaderDefault from './HeaderDefault.vue'
import HeaderModal from './HeaderModal.vue'
import HeaderProduct from './HeaderProduct.vue'
import HeaderSimple from './HeaderSimple.vue'
import HeaderInvitation from './HeaderInvitation.vue'

defineOptions({
  inheritAttrs: false,
})

withDefaults(defineProps<{
  type?: 'default' | 'product' | 'simple' | 'invitation' | 'checkout' | 'modal'
  currentUser?: CurrentUser | null
  currentTheme?: string | null
  city?: FeaturedCity | null
  disableClose?: boolean
  topCities?: FeaturedCity[]
}>(), {  })

useScreen()
provide('currentUser', (__props_currentUser))
provide('currentTheme', __props.currentTheme)
provide('topCities', __props.topCities || [])

const headerComponent = computed(() => {
  switch (__props.type) {
    case 'checkout':
      return HeaderCheckout
    case 'modal':
      return HeaderModal
    case 'product':
      return HeaderProduct
    case 'simple':
      return HeaderSimple
    case 'invitation':
      return HeaderInvitation
    default:
      return HeaderDefault
  }
})

const headerTypeRef = _ref<InstanceType<
  typeof HeaderDefault |
  typeof HeaderModal |
  typeof HeaderCheckout |
  typeof HeaderSimple |
  typeof HeaderInvitation |
  typeof HeaderProduct
>>()

defineExpose({
  closeButtonEl: (headerTypeRef.value as any)?.closeButtonEl,
})

const emit = defineEmits(['close'])
</script>

<template>
  <header id="v2-header" class="w-full bg-white flex flex-col !border-none" v-bind="$attrs">
    <div class="v2-header-content">
      <component
        :is="headerComponent"
        ref="headerTypeRef"
        :city="city"
        :disableClose="disableClose"
        @close="emit('close')"
      >
        <slot/>
      </component>
    </div>
    <div class="v2-header-print" hidden>
      <GiftlyLogoSvg/>
    </div>
  </header>
</template>

<style scoped>
@media print {
  .v2-header-content {
    display: none;
  }

  .v2-header-print {
    display: block !important;
    padding: 0.75rem 0;
  }
}
</style>
